import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
// import './assets/main.css';
import 'index.css';
import App from './App';
import CookieBot from 'react-cookiebot';
// import * as serviceWorker from './serviceWorker';

import configureStore from "./store/store";

const reduxStore = configureStore(window.REDUX_INITIAL_DATA);

const resizeObserverErrorHandler = (event) => {
  if (
    event?.message === "ResizeObserver loop completed with undelivered notifications." ||
    event?.message === "ResizeObserver loop limit exceeded"
  ) {
    event.stopImmediatePropagation();
  }
};

window.addEventListener("error", resizeObserverErrorHandler);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={reduxStore}>
    {/* <CookieBot domainGroupId={"68e52dcf-2446-4e2d-8724-cc509eefd51d"} /> */}
    	<App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
